export default __webpack_public_path__ + "static/media/forgotpassword.d3f3ff75.jpg";